export const subtitles = {
    "1": {
        "startTime": 0.43,
        "endTime": 7.13,
        "transcript": "Akilirceqaarlua caperrsaguciluni mit'ellerkaminek.",
        "translation": "After having me paid, (s)he was daunted by landing."
    },
    "2": {
        "startTime": 7.48,
        "endTime": 14.06,
        "transcript": "Tua-i-llu atraasqeńgakuk malruulunuk atrarlunuk.",
        "translation": "Then when (s)he asked us to go down, two of us went down."
    },
    "3": {
        "startTime": 14.81,
        "endTime": 25.25,
        "transcript": "Atatakuani-ll' few minutes uitaqerlua maani malillma taum call-arlua, malikeqataryaaqellma.",
        "translation": "And later, I stayed for a few minutes here, and the one I was going to go with called me."
    },
    "4": {
        "startTime": 25.74,
        "endTime": 29.95,
        "transcript": "Pussiit-gguq waniw' tagqatartut.",
        "translation": "He said the [?] were going to go inland."
    },
    "5": {
        "startTime": 31.19,
        "endTime": 36.02,
        "transcript": "Patagmek atraasqellua, atrarlua-ll'.",
        "translation": "He told me to go down quickly, and I went down."
    },
    "6": {
        "startTime": 36.17,
        "endTime": 38.84,
        "transcript": "Starting off",
        "translation": "Starting off"
    },
    "7": {
        "startTime": 39.23,
        "endTime": 48.01,
        "transcript": "Ava-i election-aallratni taangam tungiinun piciurtevkenani ayuqucimitun maa-i ayuqluni.",
        "translation": "When they had an election about alcohol, it didn't pass, and it's how it has been."
    },
    "8": {
        "startTime": 48.01,
        "endTime": 53.73,
        "transcript": "Qaillun tamana wani elpet umyuartequciu?",
        "translation": "What do you think about that?"
    },
    "9": {
        "startTime": 56.4,
        "endTime": 58.26,
        "transcript": "Piciuvkenani-qaa?",
        "translation": "It didn't pass?"
    },
    "10": {
        "startTime": 58.26,
        "endTime": 65.44,
        "transcript": "Piciurtellrunrituq au͡gna wani taangamun, ataam maani taangamek tuneniaryaurtengnaqsaaqellrat.",
        "translation": "That alcohol regulation didn't pass, the one where they tried to sell alcohol here again."
    },
    "11": {
        "startTime": 65.57,
        "endTime": 66.47,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "12": {
        "startTime": 66.47,
        "endTime": 71.91,
        "transcript": "Qaillun tamana wani piciurtenritellra umyuartequciu elpet?",
        "translation": "What do you think about how it didn't pass?"
    },
    "13": {
        "startTime": 72.05,
        "endTime": 84.93,
        "transcript": "Tamana wiinga cingumanritqapigtaqa nervigni tuniaryaurtellerkaat",
        "translation": "I absolutely do not support selling those at restaurants"
    },
    "14": {
        "startTime": 85.34,
        "endTime": 95.81,
        "transcript": "Tua-i avaken nallunrilamku man'a elluamun, elluamun atuutngunrituq.",
        "translation": "Because I've always known that this [alcohol] is not used correctly."
    },
    "15": {
        "startTime": 95.81,
        "endTime": 104.94,
        "transcript": "Maa-i nallunritanka ayagyuaput amlleret imegtut tamaaggun kill'uteng",
        "translation": "I know that many of our young people are caught in that, drowning"
    },
    "16": {
        "startTime": 104.94,
        "endTime": 109.92,
        "transcript": "Nulirqelriit-llu avvuluteng.",
        "translation": "And married couples get divorced."
    },
    "17": {
        "startTime": 110.71,
        "endTime": 124.01,
        "transcript": "Cali-llu ukuk nulirqelriit anagut'ngaqagnek irniakek teguluki utumalrianun aulukevkaraqluki.",
        "translation": "Also, when this married couple get out of hand, they take their children and have better people take care of them."
    },
    "18": {
        "startTime": 124.38,
        "endTime": 133.51,
        "transcript": "Tamana assikenritqapiara'rqa wiinga avaken ayagluku ayagyuallemni tangvallruamki.",
        "translation": "I absolutely do not like that because I've watched them from way back when I was young."
    },
    "19": {
        "startTime": 133.51,
        "endTime": 141.43,
        "transcript": "Maani anguyagteńun ayagcessvailgatnga tanglallruamki",
        "translation": "Because I used to see them before I was drafted here by the army"
    },
    "20": {
        "startTime": 141.5,
        "endTime": 146.58,
        "transcript": "Maani Mamterillernun taigaqama ikamrarlua",
        "translation": "When I would come here to Bethel by snowmachine"
    },
    "21": {
        "startTime": 146.85,
        "endTime": 158.57,
        "transcript": "Tua-i akusrartellriit tangvalaamki nallunrilamki cucukenritaqa tamana tuniaresqelluki maani nervigni.",
        "translation": "Since I watch and know those who misbehave, I do not want them to sell that in restaurants here."
    },
    "22": {
        "startTime": 159.1,
        "endTime": 164.54,
        "transcript": "Quyaqapiartua akwaugaq tekicama",
        "translation": "I'm very thankful since yesterday"
    },
    "23": {
        "startTime": 164.59,
        "endTime": 174.91,
        "transcript": "News-alriik news-allragni niicugnilukek nuu-lriit amllenruniluki.",
        "translation": "Because I listened to the news anchors reporting that nay was the majority."
    },
    "24": {
        "startTime": 174.91,
        "endTime": 178.07,
        "transcript": "Quyaqapiartua tamatumek.",
        "translation": "I'm very thankful for that."
    },
    "25": {
        "startTime": 178.22,
        "endTime": 183.74,
        "transcript": "Tua-i tau͡gaam cali taqevkenaku",
        "translation": "However, without having established it"
    },
    "26": {
        "startTime": 183.74,
        "endTime": 195.82,
        "transcript": "Umyuama paitautekciqaa cali tamana kinguqlia, waten qanrumiin:",
        "translation": "My mind will leave with you the next thing, because it says this:"
    },
    "27": {
        "startTime": 197.29,
        "endTime": 209.13,
        "transcript": "Tuniarngairucaaqellriit-gguq nervigni, maavet tau͡gaam taigurallra taq'erkauvkenani tengssuutekun.",
        "translation": "They may not seel them in restaurants anymore, but it won't stop coming here by plane."
    },
    "28": {
        "startTime": 209.13,
        "endTime": 217.58,
        "transcript": "Tamana, tamana cali ava-i unuaq niilluku news-allratni.",
        "translation": "I also just heard that this morning on the news."
    },
    "29": {
        "startTime": 217.58,
        "endTime": 226.83,
        "transcript": "Cali petition-aamek tegumiarluni sign-arcetaarilria.",
        "translation": "Also, the one asking for signatures holds a petition."
    },
    "30": {
        "startTime": 226.83,
        "endTime": 235.23,
        "transcript": "Tamatumun, tamatumun ellimaciqniluku",
        "translation": "They said that it will be put there"
    },
    "31": {
        "startTime": 238.11,
        "endTime": 243.85,
        "transcript": "Ukatmun tainanrillerkaatnun tengssuutekun.",
        "translation": "So that they will stop coming here by plane."
    },
    "32": {
        "startTime": 243.85,
        "endTime": 249.13,
        "transcript": "Tua-i cali tamana cumigutqapiarciqaqa wiinga.",
        "translation": "I will also keep a very close eye on that."
    },
    "33": {
        "startTime": 249.13,
        "endTime": 258.72,
        "transcript": "Tua-i nalluvceńi elisngalrianek ikayulirlua tua-i taringnaula'rqa.",
        "translation": "Without your knowledge, I have knowledgeable people help me to understand it."
    },
    "34": {
        "startTime": 258.72,
        "endTime": 270.8,
        "transcript": "Maa-i mat'um nalliini tua-i waten ellirluni tua-i ayuquciq tamalkuan tamarilriatun ayuqnarqelliniami",
        "translation": "Having reached this age this day, since it's like I lose everything"
    },
    "35": {
        "startTime": 270.8,
        "endTime": 279.17,
        "transcript": "Nalluyagulluki cat word-at ilait taringesciigataqluki.",
        "translation": "I forget things and can't understand some words."
    },
    "36": {
        "startTime": 279.44,
        "endTime": 286.11,
        "transcript": "Cali-llu elliqallrenka maa-i nalluyagucaurrluki mat'um ilauni.",
        "translation": "I've also started forgetting what I've put down in here."
    },
    "37": {
        "startTime": 286.11,
        "endTime": 290.95,
        "transcript": "Paivngangraata nalluluki natmun ellisia.",
        "translation": "Though they're right there, I forget where I put them."
    },
    "38": {
        "startTime": 290.95,
        "endTime": 295.78,
        "transcript": "Tua-i au͡gna quyaqekapiara'rqa wiinga.",
        "translation": "I'm very happy for what was [passed]."
    },
    "39": {
        "startTime": 297.4,
        "endTime": 304.56,
        "transcript": "Maa-i, kitak' cali maa-i waten ayuquq: taangamek itruciyugngaluteng.",
        "translation": "So, it's still like this now: they can bring in alcohol."
    },
    "40": {
        "startTime": 304.56,
        "endTime": 315.65,
        "transcript": "Cali tauna elpeni murilkellerpeni, qaillun cangallruat imumi taangamek tunenialallrat itruciyugngallrat-llu maa-i?",
        "translation": "In your observation of that, how do you compare selling alcohol back then, and being able to bring it in now?"
    },
    "41": {
        "startTime": 318.65,
        "endTime": 322.92,
        "transcript": "Atawaunrituq.",
        "translation": "It's not good."
    },
    "42": {
        "startTime": 326.89,
        "endTime": 336.16,
        "transcript": "Tua-i tunialriit wiinga tuniaresqumanritanka",
        "translation": "I don't want sellers to sell"
    },
    "43": {
        "startTime": 336.16,
        "endTime": 344.02,
        "transcript": "Cali-llu taangivingesqumavkenaki maani nunamteńi.",
        "translation": "And I don't want a liquor store here in our town."
    },
    "44": {
        "startTime": 344.02,
        "endTime": 353.34,
        "transcript": "Tua-i makut ayagyuaput maa-i nutaan nangertellriit, kingumteggun pilriit",
        "translation": "Our young people who've just stood up, who came after us"
    },
    "45": {
        "startTime": 354.73,
        "endTime": 362.27,
        "transcript": "Wangkuta, wangkuta alerquuteput nalqapiararait ayagyuat",
        "translation": "The young people know nothing about our traditional instructions"
    },
    "46": {
        "startTime": 362.27,
        "endTime": 366.11,
        "transcript": "Wangkuta Yupiani alerquuteput.",
        "translation": "Our traditional Yupiaq instructions."
    },
    "47": {
        "startTime": 366.82,
        "endTime": 373.47,
        "transcript": "Tua-i qanrucaaqellriani aitangqalartut.",
        "translation": "When spoken to, their mouths hang open."
    },
    "48": {
        "startTime": 373.47,
        "endTime": 380.01,
        "transcript": "Yugtun qalarucaaqaqamteng tutgaraanka aitangqalartut.",
        "translation": "When I speak to my grandchildren in Yup'ik, their mouths hang open."
    },
    "49": {
        "startTime": 380.01,
        "endTime": 384.76,
        "transcript": "Kass'atun tau͡gken qanrucamni nutaan ayagarrluni.",
        "translation": "Yet when I speak to them in English, they go."
    },
    "50": {
        "startTime": 384.76,
        "endTime": 387.45,
        "transcript": "Tuaten ayuqliriut tamarmeng.",
        "translation": "All of them have become like that."
    },
    "51": {
        "startTime": 387.45,
        "endTime": 398.72,
        "transcript": "And when I go to little villages, these Yupiat would only speak English, these little boys.",
        "translation": "And when I go to little villages, these Yupiat would only speak English, these little boys."
    },
    "52": {
        "startTime": 402.38,
        "endTime": 406.32,
        "transcript": "Quyakenritqapiara'rqa wii tamana.",
        "translation": "I am by no means happy about that."
    },
    "53": {
        "startTime": 406.5,
        "endTime": 415.86,
        "transcript": "Maani amllellrani, tua-i council-aarulua-llu avani",
        "translation": "When it's in plenty now, and I was part of the tribal council back then"
    },
    "54": {
        "startTime": 416.83,
        "endTime": 421.06,
        "transcript": "Ciuqvani avani ukut anglirivailgata.",
        "translation": "Way back before these people grew up."
    },
    "55": {
        "startTime": 421.06,
        "endTime": 427.34,
        "transcript": "Council-aat ilaklua fight-autekellruarput.",
        "translation": "As a part of the council, we fought for it."
    },
    "56": {
        "startTime": 428.25,
        "endTime": 440.6,
        "transcript": "Tua-i vote-arnarian, vote-aryaraq elpekngamteggu vote-arluta taqevkallruarput tamana.",
        "translation": "When it was time to vote when we noticed it was time to vote, we voted to stop that."
    },
    "57": {
        "startTime": 440.6,
        "endTime": 443.07,
        "transcript": "Amllellruyaaquq.",
        "translation": "It was a lot [accomplished]."
    },
    "58": {
        "startTime": 443.07,
        "endTime": 451.22,
        "transcript": "Tuniarviit tua-i kelucartelluki tamalkuita.",
        "translation": "We had all of the [liquor] stores close up."
    },
    "59": {
        "startTime": 451.57,
        "endTime": 461.82,
        "transcript": "Yupiani wangkuta Kass'at amllenritellratni tuani egmianun cirlakellruaput.",
        "translation": "We Yupiat, when there weren't a lot of Caucasians, overcame that right away then."
    },
    "60": {
        "startTime": 462.07,
        "endTime": 474.39,
        "transcript": "Waten yuut, yuut qavcin, talliman-llu umyuallgutekluteng qalareskuneng piniqapiartut.",
        "translation": "If several people like this, even five, speak with one mind, they are very strong."
    },
    "61": {
        "startTime": 474.48,
        "endTime": 479.0,
        "transcript": "Tau͡gaam Agayun cakaarpek'naku.",
        "translation": "But do not disregard God."
    },
    "62": {
        "startTime": 479.0,
        "endTime": 491.19,
        "transcript": "Tua-i qanellruciatun yuut pingayun quyureskata at'ni pitekluku qukaatni uitaluni.",
        "translation": "As he said, if three people are gathered in his name, he is among them."
    },
    "63": {
        "startTime": 491.19,
        "endTime": 493.92,
        "transcript": "Tua-i ilumuuluni-llu.",
        "translation": "And it's true."
    },
    "64": {
        "startTime": 493.92,
        "endTime": 504.69,
        "transcript": "Tua-i anguyagteńi uitallemni aarnarqellriami pektellruyaaqua unani Caapanit pillratni",
        "translation": "When I was in the army, I walked in a dangrous place when the Japanese went down there"
    },
    "65": {
        "startTime": 505.62,
        "endTime": 509.23,
        "transcript": "Taiyaaqellratni kanaggun nuugteggun.",
        "translation": "When they came through the points down there."
    },
    "66": {
        "startTime": 509.23,
        "endTime": 520.26,
        "transcript": "Tau͡gaam tua-i maani ayakatallemni agayulirtemta Maknerem, tayim' tuqullrull' ak'a.",
        "translation": "When I was going to leave here, our pastor Makneq, he's already died."
    },
    "67": {
        "startTime": 522.43,
        "endTime": 526.07,
        "transcript": "Maknerem alerquutii:",
        "translation": "Makneq's instruction:"
    },
    "68": {
        "startTime": 526.46,
        "endTime": 530.73,
        "transcript": "\"Piicagyaraq pegcaqunaku.\"",
        "translation": "\"Do not give up praying.\""
    },
    "69": {
        "startTime": 531.14,
        "endTime": 537.07,
        "transcript": "Tua-i tuaten tua-i tuaten taktalriamek alerqullruanga.",
        "translation": "Like that, that was the extent of his instruction to me."
    },
    "70": {
        "startTime": 537.07,
        "endTime": 539.8,
        "transcript": "Tua-i piciupiartuq.",
        "translation": "It's very true."
    },
    "71": {
        "startTime": 540.26,
        "endTime": 550.23,
        "transcript": "Tua-i ilama akuliitni arulaiqerqama tua-i eneqakerrlainarluku tau͡gaam.",
        "translation": "When I stopped among my peers, I would always remember it."
    },
    "72": {
        "startTime": 550.23,
        "endTime": 558.16,
        "transcript": "Cali-llu akusrartengraata ilanka, maa-i ilakluki tangvagluki.",
        "translation": "Also, though my peers misbehaved, I was with them and watched them."
    },
    "73": {
        "startTime": 558.88,
        "endTime": 567.3,
        "transcript": "Atakullra-llu, atakullra tamalkuan party-rturluta elitnaullemteńi",
        "translation": "And every evening, we would have parties when we were in school"
    },
    "74": {
        "startTime": 568.6,
        "endTime": 574.77,
        "transcript": "Taangat qukaatni, beer-arrlainaat qukaatni.",
        "translation": "There was alcohol among them, nothing but beer among them."
    },
    "75": {
        "startTime": 575.58,
        "endTime": 586.29,
        "transcript": "Tua-i nallunrilamku tua-i elitengnaqellrunritaqa tamana",
        "translation": "Because I knew about it, I tried not to take it up"
    },
    "76": {
        "startTime": 586.44,
        "endTime": 591.1,
        "transcript": "Iqlutun, picurlagmek iqungqerran.",
        "translation": "Because it goes wrong, and ends with misfortune."
    },
    "77": {
        "startTime": 591.68,
        "endTime": 604.19,
        "transcript": "Tua-i yugnikekma ukut Kass'ayagaat qarutelaryaaqaatnga can-amek ataucimek mer'esqellua.",
        "translation": "My Caucasian friends here would encourage me to drink one can."
    },
    "78": {
        "startTime": 604.19,
        "endTime": 606.85,
        "transcript": "Kiituan' qennguq.",
        "translation": "He eventually got mad."
    },
    "79": {
        "startTime": 607.22,
        "endTime": 617.53,
        "transcript": "Tau͡gaam maavet qaimnun tengluni tuc'etenritaa. Ataucirquungraan tengluum tut'enritaanga.",
        "translation": "But he didn't lay one fist on my body here. Not once did a fist land on me."
    },
    "80": {
        "startTime": 618.3,
        "endTime": 625.66,
        "transcript": "Tua-i qatpagatengaqanga, qatpagatengaqatnga",
        "translation": "When he started yelling at me, when they started yelling at me"
    },
    "81": {
        "startTime": 627.76,
        "endTime": 635.58,
        "transcript": "Kiugaqluki, kiugaqluki ellaicetun qanrulluki Kass'atun",
        "translation": "I would answer them, would answer them in English as in their language"
    },
    "82": {
        "startTime": 635.58,
        "endTime": 645.84,
        "transcript": "Pop-amek tau͡gaam, any kind pop kipuyuskanga aipirluku mer'aciqnilua.",
        "translation": "I said that only when he buys me a pop, any kind [of] pop, that I would drink with him."
    },
    "83": {
        "startTime": 646.44,
        "endTime": 655.09,
        "transcript": "Qenercaaqvigminek, tengluaryaaqvigminek estuuluq",
        "translation": "After he was angry and pounding the table"
    },
    "84": {
        "startTime": 655.76,
        "endTime": 661.67,
        "transcript": "Assiriluni atatakuani pop-amek kipuyullua tua-i.",
        "translation": "He'd get better later and buy me a pop."
    },
    "85": {
        "startTime": 661.67,
        "endTime": 665.75,
        "transcript": "Ellii beer-arturluni, wiinga-ll' pop-arturlua.",
        "translation": "He'd have a beer, and I'd have a pop."
    },
    "86": {
        "startTime": 665.75,
        "endTime": 668.95,
        "transcript": "Assirluni tua-i",
        "translation": "It was good."
    },
    "87": {
        "startTime": 668.95,
        "endTime": 676.89,
        "transcript": "Makut Yuullgutenka inerqurturangramteng",
        "translation": "Though I keep admonishing my fellow Yupiit"
    },
    "88": {
        "startTime": 677.35,
        "endTime": 686.99,
        "transcript": "Pingna-llu nunalgutka James Active-aaq, inerqurturangramteng",
        "translation": "And James Active inland from the same village as me, though I keep admonishing them"
    },
    "89": {
        "startTime": 686.99,
        "endTime": 696.15,
        "transcript": "Tua-i nayunrilkumni itercivigmi uitauralaryalria pingna James Active-aaq",
        "translation": "If I weren't with him, James Active inland would always be in jail"
    },
    "90": {
        "startTime": 696.15,
        "endTime": 700.34,
        "transcript": "Ilaucukapigcami makunun Kass'anun.",
        "translation": "Because he likes to [party] with these Caucasians."
    },
    "91": {
        "startTime": 700.95,
        "endTime": 706.93,
        "transcript": "Tua-i piipiqellriatun ayuqellruaqa.",
        "translation": "I treated him like my baby."
    },
    "92": {
        "startTime": 706.93,
        "endTime": 713.66,
        "transcript": "Unuakumi kinguraucetenritengnaqluku tuparqaqluku.",
        "translation": "I would wake him up in the morning so that he wouldn't be late."
    },
    "93": {
        "startTime": 713.94,
        "endTime": 725.26,
        "transcript": "Cali-llu makut mer'atunge'rmeng Kass'at alerquuteseng uniurrluku piyuilameng anguyagteńi",
        "translation": "Also, though these Caucasians drink, because they don't break their rules in the army"
    },
    "94": {
        "startTime": 725.26,
        "endTime": 730.06,
        "transcript": "Tupagyaratuqapiarluni First Sergeant-aaq.",
        "translation": "The First Sergeant always woke up very early."
    },
    "95": {
        "startTime": 730.06,
        "endTime": 736.84,
        "transcript": "Kukumyara'arluni elataitgun uivaarluki tupaqluki.",
        "translation": "He would whistle outside of them, going around to wake them up."
    },
    "96": {
        "startTime": 737.02,
        "endTime": 747.92,
        "transcript": "Tuamtell' alert-arturatuluteng unugmi, unuum...",
        "translation": "Then they would always have alerts at night, [in the middle] of the night..."
    },
    "97": {
        "startTime": 747.92,
        "endTime": 756.94,
        "transcript": "Caunivkenaku unuum qukaani eksuun uurpagaaqan",
        "translation": "Without any excuses, when the fire alarm blared"
    },
    "98": {
        "startTime": 756.94,
        "endTime": 764.75,
        "transcript": "Upluta an'aqluta, tupaqluki, tupaqluki qavalriit tamalkuita.",
        "translation": "We'd get ready, go out, and wake up everyone who was asleep."
    },
    "99": {
        "startTime": 764.75,
        "endTime": 771.33,
        "transcript": "Ayagluta-llu pavavet enet keluatnun kevraartut akuliitnun.",
        "translation": "Then we'd go inland, inland from the houses to the area between the spruce trees."
    },
    "100": {
        "startTime": 771.33,
        "endTime": 777.09,
        "transcript": "Apqaitnun foxhole-anun iirluta.",
        "translation": "We'd hide in what they called foxholes."
    },
    "101": {
        "startTime": 777.41,
        "endTime": 788.01,
        "transcript": "Tua-i-ll' nutaan sergeant-aam uivaarluta call' tekilluta uterrnaringluku.",
        "translation": "Then the sergeant would arrive and circle us when it was almost time to go back."
    },
    "102": {
        "startTime": 788.01,
        "endTime": 796.96,
        "transcript": "Eksarpiarqata Anchorage-aarmiut uurauratuuq unugmi.",
        "translation": "When there's almost a fire in Anchorage, a siren sounds at night."
    },
    "103": {
        "startTime": 800.16,
        "endTime": 810.96,
        "transcript": "Niigartellruunga wani maani Kusquqvagmi ciuqliit kalikiurtet ilakellruni[luten]. Tamatumek wani qanemciarteqerkut cali.",
        "translation": "I heard that you were one of the first mailmen here on the Kuskokwim. Please tell us about that too."
    },
    "104": {
        "startTime": 812.4,
        "endTime": 815.93,
        "transcript": "Kalikiurteńgullrunritua.",
        "translation": "I wasn't a mail man."
    },
    "105": {
        "startTime": 815.93,
        "endTime": 824.77,
        "transcript": "Ataucirqumek maligutellruunga, maligutellruunga kalikiulriamun.",
        "translation": "One time, I went with the mail delivery."
    },
    "106": {
        "startTime": 828.71,
        "endTime": 835.06,
        "transcript": "Uani Kuiggarmi Oscarville-amek atlegmi",
        "translation": "Downriver in Kuiggaq where it's called Oscarville"
    },
    "107": {
        "startTime": 835.06,
        "endTime": 841.66,
        "transcript": "Tauna wani kalikiurta uitaluni kipusvigluni.",
        "translation": "That mail man lived there and had a trading post."
    },
    "108": {
        "startTime": 842.39,
        "endTime": 845.35,
        "transcript": "Kipusvinglliniluni.",
        "translation": "He'd taken over a trading post."
    },
    "109": {
        "startTime": 845.65,
        "endTime": 854.93,
        "transcript": "Tua-i tauna wani, tauna wani qanrutkelallruat Kass'aq",
        "translation": "They would speak of that Caucasian"
    },
    "110": {
        "startTime": 854.93,
        "endTime": 862.95,
        "transcript": "Cav'urluku Kusquqvagkun maaggun asgutuniluku kalikiurluku.",
        "translation": "That he would row upriver here on the Kuskokwim to deliver mail."
    },
    "111": {
        "startTime": 863.27,
        "endTime": 875.19,
        "transcript": "Ukut-llu Qalqarmiut uatiitgun asgulriani iqsulirnermi kuiggaacuar kauluku.",
        "translation": "And when going upriver downriver from Kalskaq, we would enter the little creek on the left."
    },
    "112": {
        "startTime": 875.19,
        "endTime": 878.57,
        "transcript": "Tamaaggun asgurluta.",
        "translation": "We went upriver through there."
    },
    "113": {
        "startTime": 879.08,
        "endTime": 889.92,
        "transcript": "Atam maaken, maaken ayalriakut pingayuuluta kalikiurluta.",
        "translation": "You see, three of us traveled from here to deliver mail."
    },
    "114": {
        "startTime": 889.92,
        "endTime": 899.6,
        "transcript": "Angyaq, angya'rpaar murak ucilirluku kalikanek wani-a.",
        "translation": "The boat, we loaded a huge wooden boat with mail here."
    },
    "115": {
        "startTime": 900.51,
        "endTime": 908.76,
        "transcript": "Pi, kalikarrlainaunritut nallunritanka taum nalliini.",
        "translation": "You know, I know that they weren't all mail at that time."
    },
    "116": {
        "startTime": 908.97,
        "endTime": 916.72,
        "transcript": "Paluqtarpalluugut, pit, amit paluqtat.",
        "translation": "They were mostly beavers, you know, beaver skins."
    },
    "117": {
        "startTime": 917.04,
        "endTime": 925.14,
        "transcript": "Kalikat kalikivignun imkunun missugpagnun ekluki kelucaulluki.",
        "translation": "They would put the mail in those huge mail carrying bags and lock them."
    },
    "118": {
        "startTime": 925.14,
        "endTime": 929.07,
        "transcript": "Tua-i qalliqurluki negtaarluki.",
        "translation": "We stacked and pressed them down."
    },
    "119": {
        "startTime": 929.79,
        "endTime": 938.2,
        "transcript": "Angyaq uciliqvut, nutaan-llu canvas-aamek patuluku.",
        "translation": "We loaded the boat, then covered it with canvas."
    },
    "120": {
        "startTime": 938.2,
        "endTime": 943.42,
        "transcript": "Tuamtell' plastic-aamek qallilirluku canvas-aaq.",
        "translation": "Then we covered the canvas with plastic."
    },
    "121": {
        "startTime": 943.42,
        "endTime": 949.17,
        "transcript": "Avatii man'a ussukcaulluku ikirtarkauvkenaku.",
        "translation": "We nailed down the outer edges so it wouldn't open."
    },
    "122": {
        "startTime": 949.17,
        "endTime": 956.7,
        "transcript": "Aqumgallerkarput tau͡gaam, ciunga-llu, kingua-llu imaunani.",
        "translation": "But where we would sit, the front, and the back would be empty."
    },
    "123": {
        "startTime": 956.79,
        "endTime": 961.55,
        "transcript": "Nutaan uqurkaput kinguanun elliluki.",
        "translation": "We would put our gas reserve in the rear."
    },
    "124": {
        "startTime": 961.77,
        "endTime": 970.89,
        "transcript": "Nutaramek-llu massinvagtaituq tamatum nalliini wiinga pillemni.",
        "translation": "And there were no huge new boat motors back when I went."
    },
    "125": {
        "startTime": 970.89,
        "endTime": 980.22,
        "transcript": "Seven horse-amek Evinrude-amek nutaramek taum kipusviliurtem angyaq ellivikluku",
        "translation": "That storekeeper placed a new seven horse Evinrude motor on the boat"
    },
    "126": {
        "startTime": 980.75,
        "endTime": 983.53,
        "transcript": "Uqurkirluku-llu.",
        "translation": "And put a gas reserve in there."
    },
    "127": {
        "startTime": 983.53,
        "endTime": 993.28,
        "transcript": "Imuggun-llu Columbia-nek imkut tengalratulit pitukait.",
        "translation": "And those things that have sails that they call Columbia."
    },
    "128": {
        "startTime": 996.5,
        "endTime": 1001.99,
        "transcript": "Imarpiliurcuutait unkut Columbia-t.",
        "translation": "The Columbia boats they use to travel the ocean down there."
    },
    "129": {
        "startTime": 1003.29,
        "endTime": 1013.6,
        "transcript": "Tamatumek angturpaunrilngurmek ilumikun massiinalegmek aturluta.",
        "translation": "We used one of those those that wasn't very big with a motor in it."
    },
    "130": {
        "startTime": 1013.6,
        "endTime": 1017.74,
        "transcript": "Angyaq tauna nangcarluku asgurluta",
        "translation": "We pulled a vessel with that boat as we went upriver."
    },
    "131": {
        "startTime": 1019.04,
        "endTime": 1025.37,
        "transcript": "Qalqarmiunun-llu tekicamta ketiitnun kicarluku.",
        "translation": "When we reached Kalskag, we anchored it in the water near them."
    },
    "132": {
        "startTime": 1025.37,
        "endTime": 1029.95,
        "transcript": "Tamatukun aipaakun nangcamteggun tagluta.",
        "translation": "We went inland with that other vessel we pulled behind us."
    },
    "133": {
        "startTime": 1033.49,
        "endTime": 1037.37,
        "transcript": "Qessanrilngurmek yuarluni.",
        "translation": "He looked for one who wasn't lazy."
    },
    "134": {
        "startTime": 1037.64,
        "endTime": 1043.02,
        "transcript": "Matvi, Matvi Brasken-aamek piaqluku tauna.",
        "translation": "They called him Matvi, Matvi Brasken."
    },
    "135": {
        "startTime": 1046.23,
        "endTime": 1054.66,
        "transcript": "Elumarvigmiullrem, Elumarvigmiungullruuq.",
        "translation": "He used to be from Lomavik."
    },
    "136": {
        "startTime": 1055.2,
        "endTime": 1059.98,
        "transcript": "Elumarvigmiut nunaunrirpailgata piamta",
        "translation": "When we did that before Lomavik was deserted"
    },
    "137": {
        "startTime": 1064.84,
        "endTime": 1073.56,
        "transcript": "Au͡g'um tussilluni angutem arnaunranek tauna nuliarluni aipaqa.",
        "translation": "My companion's wife was that limping man's sister."
    },
    "138": {
        "startTime": 1078.25,
        "endTime": 1088.04,
        "transcript": "Tua-i-llu iliit tenguqerluni angutet iliit maligucugluni.",
        "translation": "Then one of the men looked strained wanting to go with us."
    },
    "139": {
        "startTime": 1088.04,
        "endTime": 1097.56,
        "transcript": "Tau-i angutni wangkuta pingayuuluta, arnamek ataucimek cetamirluta.",
        "translation": "There were three of us men, with one woman as our fourth."
    },
    "140": {
        "startTime": 1098.82,
        "endTime": 1104.47,
        "transcript": "Cetuluta, cetuqerluta, kuicuarkun au͡g'ukun asgurluta.",
        "translation": "We went downriver, then went upriver through the creek over there."
    },
    "141": {
        "startTime": 1104.47,
        "endTime": 1111.51,
        "transcript": "Nequkunani. Tua-i makut ceńii Cingik livumaaqluni.",
        "translation": "It was narrow. Here on the banks of Cingik, things would be flattened."
    },
    "142": {
        "startTime": 1111.51,
        "endTime": 1114.73,
        "transcript": "Tua-i uggigngaluni.",
        "translation": "It would be [?up on the bank]."
    },
    "143": {
        "startTime": 1114.73,
        "endTime": 1122.62,
        "transcript": "Cunaw' tan'gerlit, tan'gerlit neqsuryarait tamakut.",
        "translation": "Apparently, those were black bears' fishing areas."
    },
    "144": {
        "startTime": 1123.4,
        "endTime": 1129.58,
        "transcript": "Tua-i-llu tekitukut asgurturaqerluta.",
        "translation": "Then we arrived as we went upriver."
    },
    "145": {
        "startTime": 1129.58,
        "endTime": 1141.85,
        "transcript": "Napartaan radio pole-aq napalria waten qacarnemikun cali allamek kevraartumek piluni.",
        "translation": "The standing radio pole had another spruce tree placed on its side like this."
    },
    "146": {
        "startTime": 1141.85,
        "endTime": 1146.97,
        "transcript": "Pikaggun caviyaarmek pimaluni.",
        "translation": "It had wires up there."
    },
    "147": {
        "startTime": 1146.97,
        "endTime": 1153.01,
        "transcript": "Taum-wa napartem qacarnerani winch-aq.",
        "translation": "On the side of the that pole was a winch."
    },
    "148": {
        "startTime": 1153.62,
        "endTime": 1162.57,
        "transcript": "Taum wani taq͡urani nepingalriim operate-arcuutii.",
        "translation": "Stuck on the side of that was where you operated it."
    },
    "149": {
        "startTime": 1162.57,
        "endTime": 1168.58,
        "transcript": "Angyaput-llu tua-i ullagtelluku tamatumun.",
        "translation": "We brought our boat to that."
    },
    "150": {
        "startTime": 1169.53,
        "endTime": 1175.77,
        "transcript": "Aciakun iquugkenkun napirluku.",
        "translation": "We [?secured it] underneath at either end."
    },
    "151": {
        "startTime": 1176.83,
        "endTime": 1184.32,
        "transcript": "Mayurrluku, winch-akun mayurrluku qavirrluku-llu.",
        "translation": "We raised it with the winch and set it askew."
    },
    "152": {
        "startTime": 1184.32,
        "endTime": 1191.15,
        "transcript": "Ikamragnun yaassiigenqellriignun ekluku elliluku.",
        "translation": "We placed it into a square sled."
    },
    "153": {
        "startTime": 1191.15,
        "endTime": 1200.61,
        "transcript": "And then we would go, pushing the sled.",
        "translation": "And then we would go, pushing the sled."
    },
    "154": {
        "startTime": 1200.82,
        "endTime": 1210.42,
        "transcript": "Kevraartut ellimaluteng waten amllilleq cuqluku canirquraumaluteng.",
        "translation": "The spruce trees were placed on their sides measuring steps like this."
    },
    "155": {
        "startTime": 1210.42,
        "endTime": 1220.95,
        "transcript": "Then on the trees placed on their sides was the path for the metal wheels.",
        "translation": "Then on the trees placed on their sides was the path for the metal wheels."
    },
    "156": {
        "startTime": 1221.39,
        "endTime": 1224.64,
        "transcript": "Tamakunek akalriarluni tauna.",
        "translation": "That had those wheels."
    },
    "157": {
        "startTime": 1225.73,
        "endTime": 1230.5,
        "transcript": "Kelutmun Qass'uqitagkun ayagluta.",
        "translation": "We went inland through Qass'uqitak."
    },
    "158": {
        "startTime": 1232.14,
        "endTime": 1237.28,
        "transcript": "Merrlilriami uyungssuangaqluteng tumput.",
        "translation": "In watery paths, we would slightly bend our knees."
    },
    "159": {
        "startTime": 1237.28,
        "endTime": 1243.28,
        "transcript": "Nunapigmun-llu tua-i ugcamta nunapigkun qerarluta.",
        "translation": "And when we went up on the tundra, we crossed through the tundra."
    },
    "160": {
        "startTime": 1243.56,
        "endTime": 1248.69,
        "transcript": "Tekiartukut tuaten tua-i naparta kuigem ceńiini.",
        "translation": "We arrived and there was a pole like that on the riverbank."
    },
    "161": {
        "startTime": 1248.69,
        "endTime": 1256.91,
        "transcript": "Cunaw' Kuicaram, Kuicaram pau͡g'um Kuicaram kuigem iquanun",
        "translation": "Apparently, it was at the end of the river Kuicaraq inland"
    },
    "162": {
        "startTime": 1256.91,
        "endTime": 1264.49,
        "transcript": "Qagatiin uatiikun Tumkuvigpagmun tumii kalikiuryarat.",
        "translation": "The mail delivery path went downriver from its headwaters to Tumkuvigpak."
    },
    "163": {
        "startTime": 1264.49,
        "endTime": 1272.66,
        "transcript": "Tumyarat tuavet tua-i iqukliluni ikamraq cavik.",
        "translation": "The metal sled stopped on that path there."
    },
    "164": {
        "startTime": 1272.9,
        "endTime": 1277.88,
        "transcript": "Tua-i-ll' angyarput ekluku, ekluku.",
        "translation": "Then we put in our boat."
    },
    "165": {
        "startTime": 1277.88,
        "endTime": 1283.44,
        "transcript": "Enetarluni tauna Kuicaram ceńii.",
        "translation": "There were houses there on the banks of Kuicaraq."
    },
    "166": {
        "startTime": 1283.58,
        "endTime": 1295.81,
        "transcript": "Taum napartem keluani plywood-aaq ena tua-i piciatun taluyanek imarluni, muragnek tuaten taluyanek imarluni",
        "translation": "That plywood house inland form that pole had various fish traps in it, even had wooden fish traps in it"
    },
    "167": {
        "startTime": 1296.44,
        "endTime": 1302.15,
        "transcript": "Qalqarmiut pissurvik'lalliniamegteggu.",
        "translation": "Because the people from Kalskag fished there."
    },
    "168": {
        "startTime": 1302.23,
        "endTime": 1306.54,
        "transcript": "Tua-i-llu Kuicarakun cetuluta.",
        "translation": "Then we went downriver on through Kuicaraq."
    },
    "169": {
        "startTime": 1307.04,
        "endTime": 1311.12,
        "transcript": "Carvanra maliggluku cet'uqerrluta.",
        "translation": "We went downriver following its current."
    },
    "170": {
        "startTime": 1311.44,
        "endTime": 1323.68,
        "transcript": "Tua-i-llu avvenra, cetulriani tallirpilirnemi avvenra",
        "translation": "Then the fork, the right fork when going downriver"
    },
    "171": {
        "startTime": 1323.68,
        "endTime": 1327.63,
        "transcript": "Kuicuayaaq kaugarrluku.",
        "translation": "We slipped into the little creek."
    },
    "172": {
        "startTime": 1327.63,
        "endTime": 1330.18,
        "transcript": "Kaugarteqanemteggun...",
        "translation": "As soon as we slipped in..."
    }
};